const communities = [
  { region: "Middle Tennessee", anchor: "Nashville", cities: ["Franklin", "Brentwood", "Murfreesboro", "Hendersonville", "Smyrna", "Spring Hill", "Gallatin", "Lebanon", "Mount Juliet", "Hermitage", "Antioch", "Goodlettsville", "Dickson", "Clarksville", "Columbia"] },
  { region: "West Tennessee", anchor: "Memphis", cities: ["Germantown", "Collierville", "Bartlett", "Southaven MS", "Horn Lake MS", "Olive Branch MS", "Cordova", "Arlington", "Lakeland", "Millington", "Atoka", "Munford", "Brighton", "West Memphis AR"] },
  { region: "East Tennessee", anchor: "Knoxville", cities: ["Maryville", "Oak Ridge", "Sevierville", "Gatlinburg", "Pigeon Forge", "Farragut", "Powell", "Alcoa", "Clinton", "Lenoir City", "Morristown", "Newport"] },
  { region: "Southeast Tennessee", anchor: "Chattanooga", cities: ["East Brainerd", "Hixson", "Red Bank", "East Ridge", "Soddy-Daisy", "Signal Mountain", "Lookout Mountain", "Cleveland", "Ooltewah", "Collegedale", "Ringgold GA", "Fort Oglethorpe GA"] },
  { region: "Northeast Tennessee", anchor: "Johnson City", cities: ["Kingsport", "Bristol", "Elizabethton", "Greeneville", "Jonesborough", "Gray", "Erwin", "Watauga", "Bluff City"] },
];

export default function TennesseeCommunitiesWeServe() {
  return (
    <section id="communities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Communities We Serve</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            All of Tennessee — Every Region
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From the Music City suburbs of Middle Tennessee to the Mississippi River communities of West Tennessee, from the Great Smoky Mountains gateway to the Tri-Cities of Northeast Tennessee — Fast Passport Center serves the entire Volunteer State.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {communities.map((region, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                  <i className="ri-map-pin-2-line text-[#1A365D] text-lg"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-base">{region.region}</h3>
                  <p className="text-gray-400 text-xs">Anchored by {region.anchor}</p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2">
                {region.cities.map((city, j) => (
                  <span key={j} className="bg-white border border-gray-200 text-gray-600 text-xs px-2.5 py-1 rounded-full">
                    {city}
                  </span>
                ))}
              </div>
            </div>
          ))}
          <div className="bg-[#0F2240] rounded-lg p-7 flex flex-col justify-between">
            <div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 mb-4">
                <i className="ri-question-line text-[#F6C344] text-lg"></i>
              </div>
              <h3 className="font-bold text-white text-base mb-2">Don&apos;t see your city?</h3>
              <p className="text-white/60 text-sm leading-relaxed">
                We serve all of Tennessee — even if your city isn&apos;t listed, we can help. Our courier service reaches every corner of the Volunteer State.
              </p>
            </div>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="mt-6 inline-flex items-center gap-1.5 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
            >
              Get Started <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}